export const Currencies = {
  USD: 'USD',
};

export const CurrencySymbols = { [Currencies.USD]: '$' };
